import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "sqg-form" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-form__intro" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "L’aventure Montage commence !"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Ce premier formulaire a pour objectif d’identifier la typologie des dossiers à monter, le volume et l’interlocuteur privilégié pour les échanges d’informations si besoin. Le renseignement de la forme juridique est primordiale tout comme la convention collective s’il y en a une."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Quelle est la différence entre l’import DSN et la reprise des bulletins à l’identique ?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" La reprise des bulletins implique la réalisation des bulletins de salaires à l’identique de ce qui a été fait sur votre ancien logiciel de paie contrairement à l’import DSN où nous allons uniquement récupérer les cumuls, tranches, exonérations vous permettant au même titre que la reprise des bulletins de basculer en production au cours de l’année civile."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Import d’éléments variables : Renseignez « Oui » si vous avez un logiciel de GTA et que vous souhaitez pouvoir importer ce fichier dans Silae chaque mois."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Edition historique : Renseignez « Oui » si vous souhaitez qu’un reporting soit paramétré afin de vous permettre un export depuis Silae. ")
], -1)
const _hoisted_4 = { class: "sqg-form__actionBar" }
const _hoisted_5 = { class: "sqg-form__actionBar" }
const _hoisted_6 = { class: "sqg-form__actionBar" }
const _hoisted_7 = { class: "sqg-form__actionBar" }
const _hoisted_8 = { class: "sqg-form__actionBar" }
const _hoisted_9 = { class: "sqg-form__actionBar" }

import { computed, ComputedRef, defineAsyncComponent, defineComponent, onMounted, ref } from "vue";
import {formeJuridiquesLst, conventionCollectivesLst, getForm} from "@/functions/forms";
import { AxiosResponse } from "axios";
import apiAdmin from "@/api/spaceMountainAdminAPI";
import apiClient from "@/api/spaceMountainAPI";
import { useUserStore } from "@/stores/user";
import { storeToRefs } from "pinia";
import Modale from '@/modales/Modale.vue';
import FormTemplate from '@/forms/FormTemplate.vue';
import Loader from '@/components/Loader.vue';
import CardButton from '@/components/CardButton.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  formId: { type: String, default: '' },
  readOnly: { type: Boolean, default: false }
},
  emits: ['save'],
  setup(__props, { emit }) {

const props = __props





//STORE user
const usersStore = useUserStore();
const { user } = storeToRefs(usersStore);

//DATA
const step = ref(0);
const idTech = ref(props.formId);
const loader = ref(true);
const loaderMsg = ref('Récupération des données');

//V-MODEL
const model = ref({
  informationsCabinet: [
    { id: 1, type: "text", required: true, placeholder: "Raison sociale", field: "company_name", value: '', readOnly: true, rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }] },
    { id: 2, type: "text", required: true, placeholder: "N° client", field: "client_number", value: '', readOnly: true, rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }] },
    { id: 3, type: "text", required: true, placeholder: "N° Plateforme hébergement SILAE", field: "silae_platform_number", value: '', readOnly: true, rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }] },
    { id: 4, type: "text", required: true, placeholder: "Nom du domaine", field: "domain_name", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }] },
    { id: 5, type: "text", required: true, placeholder: "Chef de projet en charge du suivi des dossiers", field: "project_manager", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }] },
    { id: 6, type: "text", required: true, placeholder: "E-Mail", field: "company_email", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }, { msg: 'Ce champ doit être une addresse mail valide', regexp: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/ig }] },
    { id: 7, type: "text", required: true, placeholder: "Téléphone", field: "company_phone", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }, { msg: 'Ce champ doit être un numéro de téléphone valide', regexp: /^[+]?[0-9]+$/ }] },
  ],
  informationsMontage: [
    { id: 1, type: "select", required: true, placeholder: "Nombre de dossier à monter", field: "folders", choices: [ { name: "1", id: "1" }, { name: "2", id: "2" } ], value: '2' },
    { id: 2, type: "number", required: true, placeholder: "Nombre total de bulletins", field: "payslip", value: 1 },
    { id: 3, type: "date", required: true, placeholder: "Date de mise en production souhaitée", field: "mep_date", value: new Date().toISOString().split('T')[0] },
    { id: 4, type: "radio", required: true, placeholder: "Souhaitez-vous une reprise des bulletins à l'identique du PDF ? (hors import DSN)", field: "reprise_bulletins", choices: [ { name: "OUI", id: true }, { name: "NON", id: false } ], value: false },
    { id: 5, condition: { field: "reprise_bulletins", value: true }, type: "select", required: false, helper: [], placeholder: "Si OUI, nombre de mois souhaités à reprendre", field: "nb_month", value: '',
      choices: [
        { name: "1", id: "1" },
        { name: "2", id: "2" },
        { name: "3", id: "3" },
        { name: "4", id: "4" },
        { name: "5", id: "5" },
        { name: "6", id: "6" },
        { name: "7", id: "7" },
        { name: "8", id: "8" },
        { name: "9", id: "9" },
        { name: "10", id: "10" },
        { name: "11", id: "11" },
        { name: "12", id: "12" },
      ]},
    { id: 6, type: "textarea", required: false, placeholder: "Commentaires", field: "comment", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }] },
  ],
  activiteDossier1: [
    { id: 1, type: "text", required: true, placeholder: "Code Dossier", helper: ["attribué lors de la création sur Silae"], field: "folderCode", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }] },
    { id: 2, type: "select", required: true, helper: [], placeholder: "Forme juridique", field: "forme_juridique", choices: formeJuridiquesLst(), value: '' },
    { id: 3, type: "select", required: false, helper: [ "Si le dossier suit le Code du travail, il ne faut rien renseigner" ], placeholder: "Convention collective", field: "convention_collective", choices: conventionCollectivesLst(), value: '' }
  ],
  activiteDossier2: [
    { id: 1, type: "text", required: true, placeholder: "Code Dossier", helper: ["attribué lors de la création sur Silae"], field: "folderCode", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }] },
    { id: 2, type: "select", required: true, helper: [], placeholder: "Forme juridique", field: "forme_juridique", choices: formeJuridiquesLst(), value: '' },
    { id: 3, type: "select", required: false, helper: [ "Si le dossier suit le Code du travail, il ne faut rien renseigner" ], placeholder: "Convention collective", field: "convention_collective", choices: conventionCollectivesLst(), value: '' }
  ],
  parametragesSpecifiques: [
    { id: 1, type: "radio", required: true, placeholder: "Import d'éléments variables", field: "import_elements_variables", choices: [ { name: "OUI", id: true }, { name: "NON", id: false } ], value: false },
    { id: 2, type: "radio", required: true, placeholder: "Editions historiques", field: "editions_historiques", choices: [ { name: "OUI", id: true }, { name: "NON", id: false } ], value: false },
    { id: 3, type: "radio", required: true, placeholder: "Prestations catalogue", field: "prestation_catalogue", choices: [ { name: "OUI", id: true }, { name: "NON", id: false } ], value: false },
    { id: 4, condition: { field: "prestation_catalogue", value: true }, type: "select", required: false, helper: [ 'Au-delà d\'une prestation catalogue souhaitée il faudra compléter le formulaire correspondant "Formulaire prestations catalogue"' ], placeholder: "Si oui, laquelle", field: "prestation_souhaitee",
      choices: [
        { name: "Import des éléments variables (hors format par défaut)", id: "Import des éléments variables (hors format par défaut)" },
        { name: "Editions historiques spécifiques simples", id: "Editions historiques spécifiques simples" },
        { name: "Documents bureautiques spécifiques", id: "Documents bureautiques spécifiques" },
        { name: "Provisions comptables spécifiques", id: "Provisions comptables spécifiques" },
        { name: "Primes spécifiques complexes hors conventionnel (13ème mois, prime de vacances)", id: "Primes spécifiques complexes hors conventionnel (13ème mois, prime de vacances)" },
        { name: "Fichiers séquentiels spécifiques simples", id: "Fichiers séquentiels spécifiques simples" },
      ],
      value: '' },
    { id: 5, type: "radio", required: true, placeholder: "Spécificités dérogeant au conventionnel/légal", field: "derogation_conventionnel", choices: [ { name: "OUI", id: true }, { name: "NON", id: false } ], value: false },
    { id: 6, condition: { field: "derogation_conventionnel", value: true }, type: "textarea", required: false, placeholder: "Si oui, veuillez détailler les spécifités", field: "derogation_conventionnel_details", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig }] },
  ],
});

const formToSend: ComputedRef<Object> = computed(() => {
  let result: any = {
    informationsCabinet: {},
    informationsMontage: {},
    activiteDossier1: {},
    activiteDossier2: {},
    parametragesSpecifiques: {},
  };
  model.value.informationsCabinet.forEach((input: any) => {
    result.informationsCabinet[input.field] = input.value;
  });
  model.value.informationsMontage.forEach((input: any) => {
    result.informationsMontage[input.field] = input.value;
  });
  model.value.activiteDossier1.forEach((input: any) => {
    result.activiteDossier1[input.field] = input.value;
  });
  model.value.activiteDossier2.forEach((input: any) => {
    result.activiteDossier2[input.field] = input.value;
  });
  model.value.parametragesSpecifiques.forEach((input: any) => {
    result.parametragesSpecifiques[input.field] = input.value;
  });
  return result;
});

const manageStep = () => {
  if (model.value.informationsMontage.filter((item) => item.field === 'folders')[0].value === "1") step.value += 2;
  else step.value++;
};

const saveForm = () => {
  loaderMsg.value = "Sauvegarde des données";
  loader.value = true;
  step.value = 1;
  apiClient.saveForm(idTech.value, formToSend.value).then(() => {
    loader.value = false;
    emit('save');
  });
};

const submitForm = () => {
  loaderMsg.value = "Soumission du formulaire";
  loader.value = true;
  apiClient.submitForm(idTech.value, formToSend.value).then(() => {
    loader.value = false;
    emit('save');
  });
};

const api = () => {
  if (user.value.role ==='admin' || user.value.role ==='superAdmin') return apiAdmin;
  else return apiClient;
};

onMounted(() => {
  api().getForm(idTech.value).then((response: AxiosResponse) => {
    getForm(response, model.value);
    loader.value = false;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Modale, {
      title: "Formulaire d'initialisation",
      width: "50",
      height: "90",
      onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close')))
    }, {
      default: _withCtx(() => [
        (loader.value)
          ? (_openBlock(), _createBlock(Loader, {
              key: 0,
              msg: loaderMsg.value
            }, null, 8, ["msg"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (step.value === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(CardButton, {
                        width: "100",
                        height: "96",
                        icon: "fas fa-arrow-right",
                        text: "Etape suivante",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (step.value++))
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (step.value === 1)
                ? (_openBlock(), _createBlock(FormTemplate, {
                    key: 1,
                    inputs: model.value.informationsCabinet,
                    readOnly: __props.readOnly,
                    title: "Etape 1 - Votre cabinet"
                  }, {
                    default: _withCtx(({ errorCount }) => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(CardButton, {
                          width: "100",
                          height: "96",
                          icon: "fas fa-arrow-left",
                          text: "Etape précédente",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (step.value--))
                        }),
                        (!__props.readOnly)
                          ? (_openBlock(), _createBlock(CardButton, {
                              key: 0,
                              width: "100",
                              height: "96",
                              icon: "fas fa-save",
                              text: "Sauvegarder",
                              onClick: saveForm
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(CardButton, {
                          disabled: errorCount !== 0,
                          width: "100",
                          height: "96",
                          icon: "fas fa-arrow-right",
                          text: "Etape suivante",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (step.value++))
                        }, null, 8, ["disabled"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["inputs", "readOnly"]))
                : _createCommentVNode("", true),
              (step.value === 2)
                ? (_openBlock(), _createBlock(FormTemplate, {
                    key: 2,
                    inputs: model.value.informationsMontage,
                    readOnly: __props.readOnly,
                    title: "Etape 2 - Le montage"
                  }, {
                    default: _withCtx(({ errorCount }) => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(CardButton, {
                          width: "100",
                          height: "96",
                          icon: "fas fa-arrow-left",
                          text: "Etape précédente",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (step.value--))
                        }),
                        (!__props.readOnly)
                          ? (_openBlock(), _createBlock(CardButton, {
                              key: 0,
                              width: "100",
                              height: "96",
                              icon: "fas fa-save",
                              text: "Sauvegarder",
                              onClick: saveForm
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(CardButton, {
                          disabled: errorCount !== 0,
                          width: "100",
                          height: "96",
                          icon: "fas fa-arrow-right",
                          text: "Etape suivante",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (step.value++))
                        }, null, 8, ["disabled"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["inputs", "readOnly"]))
                : _createCommentVNode("", true),
              (step.value === 3)
                ? (_openBlock(), _createBlock(FormTemplate, {
                    key: 3,
                    inputs: model.value.activiteDossier1,
                    readOnly: __props.readOnly,
                    title: "Etape 3 - Dossier 1"
                  }, {
                    default: _withCtx(({ errorCount }) => [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(CardButton, {
                          width: "100",
                          height: "96",
                          icon: "fas fa-arrow-left",
                          text: "Etape précédente",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (step.value--))
                        }),
                        (!__props.readOnly)
                          ? (_openBlock(), _createBlock(CardButton, {
                              key: 0,
                              width: "100",
                              height: "96",
                              icon: "fas fa-save",
                              text: "Sauvegarder",
                              onClick: saveForm
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(CardButton, {
                          disabled: errorCount !== 0,
                          width: "100",
                          height: "96",
                          icon: "fas fa-arrow-right",
                          text: "Etape suivante",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (step.value++))
                        }, null, 8, ["disabled"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["inputs", "readOnly"]))
                : _createCommentVNode("", true),
              (step.value === 4)
                ? (_openBlock(), _createBlock(FormTemplate, {
                    key: 4,
                    inputs: model.value.activiteDossier2,
                    readOnly: __props.readOnly,
                    title: "Etape 3 - Dossier 2"
                  }, {
                    default: _withCtx(({ errorCount }) => [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(CardButton, {
                          width: "100",
                          height: "96",
                          icon: "fas fa-arrow-left",
                          text: "Etape précédente",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (step.value--))
                        }),
                        (!__props.readOnly)
                          ? (_openBlock(), _createBlock(CardButton, {
                              key: 0,
                              width: "100",
                              height: "96",
                              icon: "fas fa-save",
                              text: "Sauvegarder",
                              onClick: saveForm
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(CardButton, {
                          disabled: errorCount !== 0,
                          width: "100",
                          height: "96",
                          icon: "fas fa-arrow-right",
                          text: "Etape suivante",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (step.value++))
                        }, null, 8, ["disabled"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["inputs", "readOnly"]))
                : _createCommentVNode("", true),
              (step.value === 5)
                ? (_openBlock(), _createBlock(FormTemplate, {
                    key: 5,
                    inputs: model.value.parametragesSpecifiques,
                    readOnly: __props.readOnly,
                    title: "Etape 4 - Informations spécifiques"
                  }, {
                    default: _withCtx(({ errorCount }) => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(CardButton, {
                          width: "100",
                          height: "96",
                          icon: "fas fa-arrow-left",
                          text: "Etape précédente",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (step.value--))
                        }),
                        (!__props.readOnly)
                          ? (_openBlock(), _createBlock(CardButton, {
                              key: 0,
                              width: "100",
                              height: "96",
                              icon: "fas fa-save",
                              text: "Sauvegarder",
                              onClick: saveForm
                            }))
                          : _createCommentVNode("", true),
                        (!__props.readOnly)
                          ? (_openBlock(), _createBlock(CardButton, {
                              key: 1,
                              disabled: errorCount !== 0,
                              width: "100",
                              height: "96",
                              icon: "fas fa-paper-plane",
                              text: "Soumettre",
                              onClick: submitForm
                            }, null, 8, ["disabled"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["inputs", "readOnly"]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _: 1
    })
  ]))
}
}

})